import React from "react";

const ProductsAccordion = ({
    inclusiveProducts = [],
    exclusiveProducts = [],
    isOpen,
    onToggle
}) => {
    const [inclusiveSearch, setInclusiveSearch] = React.useState("");
    const [exclusiveSearch, setExclusiveSearch] = React.useState("");

    const filteredInclusive = inclusiveProducts.filter(p =>
        p.toLowerCase().includes(inclusiveSearch.toLowerCase())
    );

    const filteredExclusive = exclusiveProducts.filter(p =>
        p.toLowerCase().includes(exclusiveSearch.toLowerCase())
    );

    return (
        <div className="product-accordion full-width">
            {/* HEADER */}
            <div className="accordion-header" onClick={onToggle}>
                <span>
                    Products ({inclusiveProducts.length + exclusiveProducts.length})
                </span>
                <span className={`arrow ${isOpen ? "open" : ""}`}>▼</span>
            </div>

            {isOpen && (
                <div className="accordion-body open">
                    <div className="product-grid">

                        {/* INCLUSIVE COLUMN */}
                        <div className="product-column">
                            <div className="column-header">
                                <span className="column-title">
                                    Inclusive Products ({inclusiveProducts.length})
                                </span>

                                {inclusiveProducts.length > 0 && (
                                    <input
                                        type="text"
                                        placeholder="Search"
                                        className="product-search"
                                        value={inclusiveSearch}
                                        onChange={(e) =>
                                            setInclusiveSearch(e.target.value)
                                        }
                                    />
                                )}
                            </div>

                            <div className="column-scroll">
                                {inclusiveProducts.length === 0 ? (
                                    <span className="empty-text">
                                        No inclusive products
                                    </span>
                                ) : filteredInclusive.length > 0 ? (
                                    filteredInclusive.map((p, i) => (
                                        <span key={i} className="detail-chip">
                                            {p}
                                        </span>
                                    ))
                                ) : (
                                    <span className="empty-text">
                                        No matching inclusive products
                                    </span>
                                )}
                            </div>
                        </div>

                        {/* EXCLUSIVE COLUMN */}
                        <div className="product-column">
                            <div className="column-header">
                                <span className="column-title">
                                    Exclusive Products ({exclusiveProducts.length})
                                </span>

                                {exclusiveProducts.length > 0 && (
                                    <input
                                        type="text"
                                        placeholder="Search"
                                        className="product-search"
                                        value={exclusiveSearch}
                                        onChange={(e) =>
                                            setExclusiveSearch(e.target.value)
                                        }
                                    />
                                )}
                            </div>

                            <div className="column-scroll">
                                {exclusiveProducts.length === 0 ? (
                                    <span className="empty-text">
                                        No exclusive products
                                    </span>
                                ) : filteredExclusive.length > 0 ? (
                                    filteredExclusive.map((p, i) => (
                                        <span key={i} className="detail-chip">
                                            {p}
                                        </span>
                                    ))
                                ) : (
                                    <span className="empty-text">
                                        No matching exclusive products
                                    </span>
                                )}
                            </div>
                        </div>

                    </div>
                </div>
            )}
        </div>
    );
};

export default ProductsAccordion;
